import { useMemo } from "react";
import { Button, Card, Flex, Grid, QueryLoader } from "@jsq/ds/core";
import { useFeatureFlag } from "@jsq/flags-react";
import { useGetTransferBatchesQuery } from "~/graphql/supergraphHooks";
import { QueryResult } from "../../TransferOnlySyncTakeover";
import { NO_TRANSFER_HISTORY } from "../constants";
import EmptyState from "../Empty";
import { getSyncedBy } from "../utils";
import { Row, colDefs, gridOptions, getRowData } from "./utils";

type Props = {
  selectedEntityId: number;
  arenaId: number;
  onSync: () => void;
};

const TransferGlBatchHistoryTable = (props: Props) => {
  const enableResyncTransfer = useFeatureFlag("resyncTransfer", false);
  const transferBatchResponse = useGetTransferBatchesQuery({
    variables: {
      entityId: props.selectedEntityId,
      arenaId: props.arenaId ? props.arenaId : 0,
      isProcessed: true,
    },

    skip: !props.selectedEntityId || !props.arenaId,
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });
  const glBatchData: QueryResult = transferBatchResponse?.data
    ? transferBatchResponse.data.entityTransferGlBatchesDetails
    : { unsynced: [], history: [] };

  const historyData: Row[] = useMemo(() => {
    const rows: Row[] = glBatchData.history.map((batch) => {
      const batchDate = typeof batch.batchDate === "string" ? batch.batchDate : "";
      const description = typeof batch.description === "string" ? batch.description : "";
      const lastSyncAt = typeof batch.lastSyncAt === "string" ? batch.lastSyncAt : null;
      const lastSyncUserName =
        typeof batch.lastSyncUserName === "string" ? batch.lastSyncUserName : null;
      return {
        batchDate,
        description,
        syncedBy: getSyncedBy(lastSyncAt, lastSyncUserName),
      };
    });
    rows.sort((a, b) => new Date(a.batchDate).getTime() - new Date(b.batchDate).getTime());
    return rows;
  }, [glBatchData.history]);

  return (
    <Card style={{ border: "none" }}>
      <QueryLoader result={[transferBatchResponse]}>
        {historyData.length === 0 ? (
          <EmptyState text={NO_TRANSFER_HISTORY} />
        ) : (
          <Grid
            gridOptions={gridOptions}
            rowData={getRowData(historyData)}
            columnDefs={colDefs}
          />
        )}
        {enableResyncTransfer && (
          <Flex
            justifyContent="flex-end"
            style={{
              marginTop: "24px",
            }}
          >
            <Button
              variant="primary"
              onClick={() => {
                props.onSync();
              }}
            >
              Sync transfers
            </Button>
          </Flex>
        )}
      </QueryLoader>
    </Card>
  );
};

export default TransferGlBatchHistoryTable;
